import { useCallback } from "react";

import { numberToCurrency } from "../_common/utils/currency";

export default function useFormatCurrency() {
  return useCallback(numberToCurrency, []);
}
